// extracted by mini-css-extract-plugin
export default {"root":"vMg0q"};